import { lazy } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import App from '../App';
import ScrollToTop from '../components/scrollToTop';
import NonAuthLayout from '../layout/non-auth-layout';
import Catalogue from "../pages/catalogues/catalogues";
import CatalogueInner from '../pages/catalogues/components/catalogueInner';
import ViewPDF from '../pages/catalogues/components/viewPDF';
import WaltzPDF from "../pages/catalogues/components/waltzPDF";
import ContactUsPage from '../pages/contactUs/contact-us';
import Glass from '../pages/glass/glass';
import Library from '../pages/library/library';
import GetQuotation from '../pages/products/components/getQuotation';
import Quotation from '../pages/products/components/quotation';
import ProductsPage from '../pages/products/products';

const HomePage = lazy(() => import('../pages/Home/home'));
const AboutUsPage = lazy(() => import('../pages/aboutUs/about-us'));
const ProductCloseNxtPage = lazy(() => import('../pages/products/components/productCloseNxt'));
const ProductSlideNxtPage = lazy(() => import('../pages/products/components/productSlideNxt'));
const ProductGlideNxtPage = lazy(() => import('../pages/products/components/productGlideNxt'));
const ProductSwingNxtPage = lazy(() => import('../pages/products/components/productSwingNxt'));
const ExhibitionPage = lazy(() => import('../pages/aboutUs/exhibition'));
const PrivacyPolicyPage = lazy(() => import('../pages/privacyPolicy/privacy-policy'));
const TermsAndConditionsPage = lazy(() => import('../pages/termsAndConditions/terms-and-conditions'));
const PageNotFoundPage = lazy(() => import("../pages/page-not-found/page-not-found"));
const AddContactUsPage = lazy(() => import("../pages/addContacts/add-contacts"));
const IndiaDesignPage = lazy(() => import("../pages/indiaDesign/india-design"));
const IndiaDesignInvitePage = lazy(() => import("../pages/india-design-invite/india-design-invite"));
const QualifiedTradersPage = lazy(() => import("../pages/qualifiedTradersPage/qualified-traders-form"));

function AppRoutes() {
    return (
        <>
            <App />
            <BrowserRouter>
                <ScrollToTop />
                <Routes>
                    <Route path='' element={<NonAuthLayout page={<HomePage />} />} />

                    <Route path='about-us' element={<NonAuthLayout page={<AboutUsPage />} />} />

                    <Route path='exhibition' element={<NonAuthLayout page={<ExhibitionPage />} />} />

                    <Route path='products' element={<NonAuthLayout page={<ProductsPage />} />} />

                    <Route path='contact-us' element={<NonAuthLayout page={<ContactUsPage />} />} />

                    <Route path='quotation' element={<NonAuthLayout page={<Quotation />} />} />

                    <Route path='get-quotation' element={<NonAuthLayout page={<GetQuotation />} />} />

                    <Route path='glass' element={<NonAuthLayout page={<Glass />} />} />

                    <Route path='catalogues-download' element={<NonAuthLayout page={<Catalogue />} />} />

                    <Route path='catalogues-inner' element={<NonAuthLayout page={<CatalogueInner />} />} />

                    <Route path='view-pdf' element={<NonAuthLayout page={<ViewPDF />} />} />

                    <Route path='waltz-pdf' element={<NonAuthLayout page={<WaltzPDF />} />} />

                    <Route path='product' element={<NonAuthLayout page={<ProductsPage />} />} />

                    <Route path='privacy-policy' element={<NonAuthLayout page={<PrivacyPolicyPage />} />} />

                    <Route path='terms-and-conditions' element={<NonAuthLayout page={<TermsAndConditionsPage />} />} />

                    <Route path='/product'>
                        <Route path='waltz/close-nxt' element={<NonAuthLayout page={<ProductCloseNxtPage />} />} />
                        <Route path='waltz/slide-nxt' element={<NonAuthLayout page={<ProductSlideNxtPage />} />} />
                        <Route path='waltz/glide-nxt' element={<NonAuthLayout page={<ProductGlideNxtPage />} />} />
                        <Route path='waltz/swing-nxt' element={<NonAuthLayout page={<ProductSwingNxtPage />} />} />
                    </Route>

                    <Route path='library' element={<NonAuthLayout page={<Library />} />} />

                    <Route path="add-contact" element={<NonAuthLayout page={<AddContactUsPage />} />} />

                    {/* <Route path="india-design" element={<NonAuthLayout page={<IndiaDesignPage />} />} />

                    <Route path='india-design-invite/:salesPersonId/:whatsappNumber' element={<NonAuthLayout page={<IndiaDesignInvitePage />} />} /> */}

                    <Route path='qualified-traders/:id' element={<NonAuthLayout page={<QualifiedTradersPage />} />} />

                    <Route path="*" element={<PageNotFoundPage />} />

                </Routes>
            </BrowserRouter>
        </>
    )
}

export default AppRoutes;